<template>
  <SubLayout
      :pageTitle="title"
      :pageBreadcrumbs="breadcrumbs"
      :hasBack="true"
  >
      <template #layoutContent>
        <NpsForm :default-form="defaultForm" :submit-form="updateNps" :loading="loading" :getting="getting" :title="$t('nps.update')" :show="true"/>
        <NpsInvitationModal id="send_nps_invitation"/>
      </template>
  </SubLayout>
</template>

<script setup>
import {computed, nextTick, onMounted, ref, watch} from "vue";
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import {useStore} from "vuex";
import {useRouter, useRoute} from "vue-router";
import {useLocales} from "@/composables/locales";
import {useHasAbility} from "@/composables/hasAbility";
import NpsForm from "../../components/NpsForm.vue";
import NpsInvitationModal from "../../components/Modal/NpsInvitationModal.vue";

const route = useRoute()
const router = useRouter()

const store = useStore()
const { can } = useHasAbility()
const { locale } = useLocales()

const title = ref("breadcrumbs.nps")
const breadcrumbs = ref([
{
  name: 'breadcrumbs.views',
  route: 'nps'
}
])

const getting = ref(false)
const loading = ref(false)
const defaultForm = ref({})

const company = computed(() => store.getters['offices/getSelectedCompany'])

watch(() => route.params.id, () => {
  if(route.params.id){
    loadNps()
  }
})

const loadNps= () => {
  getting.value = true
  store.dispatch('nps/getNps', route.params.id).then((resp) => {
    initForm(resp.data.data)
  })
  .finally(() => getting.value = false)
}


function updateNps({data, submit}){  
  loading.value = true
  store.dispatch('nps/updateNps', {...data, society_id: company?.value.id, name: data?.title})
      .then(res => {
        window.toastr['success'](i18n.global.t("notification.nps_updated"))
        if(submit){
          router.push({name:"nps-details", params: {id: res.data.data.id}})
        }
      })
      .catch((err) => {
      })
      .finally(() => loading.value = false)
}

const loadFieldTypes = () => {
  store.dispatch('nps/getFieldTypes')
}

function initForm(nps){
  let data = []
  nps?.form?.fields?.forEach(field => {
      data.push({
        type: field.type || 'text',
        label: field.label || '',
        name: field.name || '',
        placeholder: field.placeholder || '',
        required: field.required || false,
        options: field.options || [],
        extensions: field.extensions || [],
        repeatable: field.repeatable || false,
        can_delete: field.can_delete
      })
  });

  defaultForm.value =  {
    id:nps?.id,
    title:nps?.title,
    name:nps?.title,
    nps_description:nps?.nps_description,
    icon:nps?.icon,
    society_id:nps?.form?.society?.id,
    min_value: 1,
    max_value:10,
    fields: data
  }
}

onMounted(() => {
  loadFieldTypes()
  store.dispatch('mail/loadMailMessage')

  if(route.params.id){
    loadNps()
  }
  //loadNps()
})

</script>

<style scoped>
.password-input {
  position: relative;
}

.toggle-password {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}

#eye-icon {
  font-size: 1.2em;
}
</style>
